module.exports = __webpack_public_path__ + "img/shiyuanhui big (8).90a29f0b.jpg";